import React, { Fragment, useEffect, useState } from 'react';
import * as Yup from "yup";
import { Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import TextInput from '../../../components/InputFields/TextInput';
import { useFormik } from 'formik';
import "./Forms.css";
import { formikEditPdfForm } from '../Constant';
import { getApplicationType, getAllSigner, updatePdfForm } from '../../../api/workflow';
import { decryptData } from '../../../utils/helper';
import { failed, success } from '../../../utils/Tostify';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../components/Loader/Loader';
import MultiSelect from '../../../components/InputFields/MultiSelect';
import { useGetStates } from '../../../hooks/useGetStates';

const EditForm = ({refetch, setShowModal, formdata }) => {
    let token = useSelector(state => state.userReducer.token);
    const [isLoading, setIsLoading] = useState(false);
    const [applicationList, setApplicationList] = useState(false);
    const [signerList, setsignerList] = useState([]);
    const dispatch  = useDispatch();
    const { states } = useGetStates("US");
    const [statesList, setStateList] = useState([]);
    useEffect(() => {
        if (states && states.length > 0) {
            const formattedStates = states.map((obj) => ({
                label: obj.name,
                value: obj.name
            }));
            setStateList(formattedStates);
        }
    }, [states]);

    const formik = useFormik({
        ...formikEditPdfForm,
        validationSchema: Yup.object({
            formTitle: Yup.string().required("Required Field"),
            applicationTypeId: Yup.string().required("Required Field"),
            // documentTypeId: Yup.string().required("Required Field"),
            stateId: Yup.string().required("Required Field")
        }),
        onSubmit: async (values) => {
            let res;
            try {
                setIsLoading(true);
                res = await updatePdfForm({ values, dispatch, token, formId: formdata?._id });
                if (res?.status == "SUCCESS") {
                    setShowModal();
                    setIsLoading(false);
                    success(res?.message);
                    await refetch();
                }else{
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        }
    });

    const getSigners = async (page, limit, searchKey = "") => {
        let res;
        try {
            setIsLoading(true);
            res = await getAllSigner({dispatch, token, page, limit, searchKey, dataLimit: "all"});
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                setsignerList(responseData.items);
                setIsLoading(false);
            }else{
              setIsLoading(false);
              failed(res?.message);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

      const getApplicationTypeList = async (page, limit, searchKey = "") => {
        let res;
        try {
            setIsLoading(true);
            // setSearch(searchKey);
            res = await getApplicationType({dispatch, token, page, limit, searchKey, dataLimit: "all"});
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                setApplicationList(responseData?.items.filter((item)=> item?.isPublished !== false).map((obj)=> {
                    return {
                    label : obj?.applicationTitle,
                    value : obj?._id
                };}));
                setIsLoading(false);
            }else{
              setIsLoading(false);
              failed(res?.message);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
      };


    const handlesigner = (e)=>{
        const { value, checked } = e.target;
        if (checked) {
          formik.setFieldValue('signer', [...formik.values.signer, signerList?.find((obj)=> obj?._id == value)]);
        } else {
          formik.setFieldValue('signer', formik.values.signer.filter((item) => item._id !== value));
        }
    };

    const handleState =(e)=>{
        formik.setFieldValue("stateId", e.target.value);
        formik.setFieldValue("state", statesList.find((obj)=> obj?.value === e.target.value));
    };

    const setEditData =()=>{
        formik.setFieldValue("formTitle", formdata?.formTitle);
        formik.setFieldValue("applicationTypeId", formdata?.applicationType?._id);
        formik.setFieldValue("documentTypeId", formdata?.documentType?._id);
        formik.setFieldValue("stateId", formdata?.state.value);
        formik.setFieldValue("state", formdata?.state);
        formik.setFieldValue("signer", formdata.signer);
        formik.setFieldValue("isSignatureReq", formdata.signer.length > 0 ? true : false);
    };

    useEffect(() => {
      getApplicationTypeList();
      getSigners();
      setEditData();
    }, []);

  return (
    <Fragment>
      <Modal isOpen={setShowModal} toggle={()=>{setShowModal();}} size="lg" className='user_modal_block'>
        <ModalHeader toggle={setShowModal} className="assign_blk">{formdata.readOnly ? `View PDF Form` : `Edit PDF Form`}</ModalHeader>
        <Form onSubmit={formik.handleSubmit}>
        <ModalBody className="assign_modal_body">
        {isLoading ? <Loader /> : null}
            <div className="add_forms_workflow" style={{padding : "0px 15px 20px"}}>
                    <div className="first_block mb-0">
                        <Row>
                            <Col lg={6} className="location_block">
                                <TextInput
                                    keyField={"formTitle"}
                                    formik={formik}
                                    readOnly={formdata.readOnly}
                                    label="PDF Form Title"
                                    placeholder={"PDF Form Title"}
                                    type="text"
                                    value={formik.values.formTitle}
                                    onChange={(e) => formik.setFieldValue("formTitle", e.target.value)}
                                />
                            </Col>
                            <Col lg={6} className="location_block">
                                <MultiSelect
                                    keyField={"applicationTypeId"}
                                    multiple={false}
                                    disabled={formdata.readOnly}
                                    formik={formik}
                                    label="Application Type"
                                    options={applicationList}
                                    placeholder="Application Type"
                                    value={formik.values.applicationTypeId}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6} className="location_block">
                                <TextInput
                                    keyField={"stateId"}
                                    formik={formik}
                                    label="State"
                                    readOnly={formdata.readOnly}
                                    options={statesList}
                                    type="select"
                                    value={formik.values.stateId}
                                    onChange={(e) => handleState(e)}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6} className="location_block uploading_block">
                            </Col>
                            <Col lg={6} className="location_block">
                                <FormGroup check className="custom-checkbox">
                                    <Input type="checkbox" id="customCheckbox" checked={formik.values.isSignatureReq} onClick={(e)=> {
                                        formik.setFieldValue("isSignatureReq", e.target.checked);
                                        if(e.target.checked === false){
                                            formik.setFieldValue("signer", []);
                                        }
                                    }}/>
                                    <Label check>Signature Required</Label>
                                </FormGroup>
                                {formik.values.isSignatureReq ? <div className="signer_block">
                                    <div className='signer_header'>
                                        <h6>Signer</h6>
                                    </div>
                                    <div className="data_signer_block" >
                                    {signerList?.length > 0  && signerList.map((obj)=> (
                                        <div className='data_sign_first' key={obj?._id}>
                                            <FormGroup check className="custom-checkbox" >
                                                <Input type="checkbox" id={obj?._id} disabled={formdata.readOnly} value={obj?._id} onClick={handlesigner} defaultChecked={formdata?.signer?.map(val=> val._id).includes(obj?._id)}/>
                                                <Label check>
                                                    {obj?.signer}
                                                </Label>
                                            </FormGroup>
                                        </div>
                                    ))}
                                    </div>
                                    {formik?.touched["signer"] && formik?.errors["signer"] && ( <div style={{color : "red"}}>{"Required field"}</div>)}
                                </div> : null}
                            </Col>
                        </Row>
                    </div>
            </div>
        </ModalBody>
        <ModalFooter className="p-0 mt-3">
          {!formdata.readOnly ? <div className="d-flex justify-content-center gap-5 mb-4">
            <button className="save_btn" onClick={setShowModal}>Close</button>
            <button className="save_btn second" type="submit">Save</button>
          </div> : null}
        </ModalFooter>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default EditForm;
